import {
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import * as React from 'react';

import { Emoji } from '@/imports/ui/chakra/components/Emoji';

type ISuccessModal = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
};

export const SuccessModal: React.FC<ISuccessModal> = ({
  isOpen,
  onClose,
  title = 'Your Bulk Import is in Progress',
  description = `Depending on the size of your import, it might take some time to process. We'll send you an email with your import details once it's complete!`,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
      <ModalOverlay />

      <ModalContent>
        <ModalCloseButton />

        <ModalBody textAlign="center" pt="16" px="6">
          <Emoji
            label="pointing up"
            symbol="☝️"
            fontSize="4xl"
            lineHeight="normal"
          />

          <Heading as="h4" size="md" pt="2">
            {title}
          </Heading>
          <Text pt="2">{description}</Text>
        </ModalBody>

        <ModalFooter>
          <Button onClick={onClose}>Got it!</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
